import Logger from 'live/services/logger'

const logger = Logger('Plugin-alerts-dashboard-channels')

/**
 * Overwrites the XMLHttpRequest open and send methods to intercept the request payload
 *
 * @todo Live issues - in case of an unexpected behavior check Live and stop the plugin
 * @see https://gitlab.intelie.com/intelie/live/-/blob/8d6187a1366d5a31442b243d932ef66becdcbfb4/webapp/js/live-core/polyfillsUtils.ts#L86
 */
export const overwriteXhr = (map: Map<number, LiveWidgetRequest>): void => {
    const open = XMLHttpRequest.prototype.open
    const send = XMLHttpRequest.prototype.send

    XMLHttpRequest.prototype.open = function (method, url) {
        this._url = url

        return open.apply(this, [method, url])
    }

    XMLHttpRequest.prototype.send = function (...args) {
        if (this._url.includes('widget-query')) {
            try {
                const requestPayload = JSON.parse((args as unknown) as string) as LiveWidgetRequest[]
                requestPayload.forEach(request => {
                    map?.set(request.widgetId, request)
                })
            } catch (e) {
                console.log('Request Interceptor parse error - Plugin-alerts-dashboard-channels:', e)
            }
        }

        return send.apply(this, [...args])
    }

    logger.warn('XMLHttpRequest open and send methods were overwritten')
}

/**
 * Removes the timezone from the span
 *
 * @param span ts Americas/Sao_Paulo (ts 0 to ts 1000)
 * @returns "ts 0 to ts 1000"
 */
export const removeTzFromSpan = (span: string): string => {
    const match = span.match(/\((.*)\)/)

    return match ? match.pop() : span
}
